document.addEventListener("DOMContentLoaded", (event) => {
    setTimeout(function () {
      let text_boxs = document.querySelectorAll("textarea.pplr_text.pplr_monogram");
      let width_counter = document.querySelector("#width_count");
      let height_counter = document.querySelector("#height_count");
      let sizelabels = document.querySelectorAll('.pplr-drop-item');
  
      let width_default = 6;
      let height_default = 20;
      let height_count = 1;
  
      for (let i = 0; i < sizelabels.length; i++) {
        const sizelabel = sizelabels[i];
        sizelabel.addEventListener('click', function(e){
          let size = document.querySelector('.pplr_select.pplraddprice.cstmfy_c_required').value;
          if(size === 'XS'){
            width_default = 6;
            height_default = 20;
            width_counter.innerHTML = (text_box_length *  width_default);
            height_counter.innerHTML = (height_count *  height_default);
          } else if(size === 'S'){
            width_default = 7;
            height_default = 23.33;
            width_counter.innerHTML = (text_box_length *  width_default);
            height_counter.innerHTML = (height_count *  height_default);
          } else if(size === 'M'){
            width_default = 8;
            height_default = 26.66;
            width_counter.innerHTML = (text_box_length *  width_default);
            height_counter.innerHTML = (height_count *  height_default);
          } else if(size === 'L'){
            width_default = 9;
            height_default = 30;
            width_counter.innerHTML = (text_box_length *  width_default);
            height_counter.innerHTML = (height_count *  height_default);
          } else if(size === 'XL'){
            width_default = 10;
            height_default = 33.33;
            width_counter.innerHTML = (text_box_length *  width_default);
            height_counter.innerHTML = (height_count *  height_default);
          } else if(size === 'XXL'){
            width_default = 11;
            height_default = 36.66;
            width_counter.innerHTML = (text_box_length *  width_default);
            height_counter.innerHTML = (height_count *  height_default);
          } else if(size === 'XXXL'){
            width_default = 12;
            height_default = 40;
            width_counter.innerHTML = (text_box_length *  width_default);
            height_counter.innerHTML = (height_count *  height_default);
          }
          
        });
      }
  
      for (let i = 0; i < text_boxs.length; i++) {
        const text_box = text_boxs[i];
        
        text_box.addEventListener("keyup", function (e) {
  
          let text = e.target.value;
    
          if (e.key !== 'Enter' && e.key !== 'Backspace') {
            let text_box_value=text_box.value;
            let mx=-1;
            let text_box_array=text_box_value.split('\n')
            for (let i = 0; i < text_box_array.length; i++) {
              const single_text_box_length = text_box_array[i].length;
              mx=Math.max(mx,single_text_box_length)
            }
            text_box_length=mx
          } else if(e.key === 'Enter' || e.key === 'Backspace'){
            let text_box_value=text_box.value;
            let mx=-1;
            let text_box_array=text_box_value.split('\n')
            for (let i = 0; i < text_box_array.length; i++) {
              const single_text_box_length = text_box_array[i].length;
              mx=Math.max(mx,single_text_box_length)
            }
            text_box_length=mx
            height_count=text_box_array.length;
          }
    
          if(text_box_length){
            width_counter.innerHTML = (text_box_length * width_default);
          }
          height_counter.innerHTML = (height_count * height_default);
        });
      }
      
    }, 3000);
  });
  